import {
  getLessonList,
  pathCreateLesson,
  pathDeleteLesson,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { lessonActions } from "../reducers/lesson";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchLessonList = (id_lesson = 0) => {
  return (dispatch) => {
    return apiService
      .get(getLessonList(id_lesson))
      .then((response) => {
        id_lesson == 0
          ? dispatch(lessonActions.fetchLessonList(response.data))
          : dispatch(lessonActions.fetchLessonDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const clearLessonDetail = () => {
  return (dispatch) => {
    dispatch(lessonActions.fetchLessonDetail([]));
  };
};

export const createNewLesson = (data, navigate) => {
  return async () => {
    try {
      const response = await apiService.postMultipart(pathCreateLesson(), data);
      navigate("/lesson-list");
      toast.success(t("lessonsListActions.created"), {
        theme: "colored",
      });
    } catch (err) {
      handleError(err);
    }
  };
};

export const createNewLesson1 = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .postMultipart(pathCreateLesson(), data)
      .then((response) => {
        // dispatch(lessonActions.fetchLessonList(response.data));
        toast.success(t("lessonsListActions.created"), {
          theme: "colored",
        });
        navigate("/lesson-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditLesson = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .putMultipart(pathCreateLesson(), data)
      .then((response) => {
        // dispatch(lessonActions.fetchLessonList(response.data));
        toast.success(t("lessonsListActions.updated"), {
          theme: "colored",
        });
        navigate("/lesson-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteLesson = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteLesson(id))
      .then((response) => {
        toast.success(t("lessonsListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchLessonList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
